<template>
  <div class="overflow-visible">
    <InputLabel :labelClass="label_class" :forId="id" :label="label" />
    <input
      :id="id"
      :type="type"
      :value="modelValue"
      :class="input_class"
      :placeholder="placeholder"
      :disabled="is_disabled"
      :required="is_required"
      v-bind="$attrs"
      @input="$emit('update:modelValue', $event.target.value)"
      class="block font-medium !text-lg mt-1 flex-1 accent-white rounded-3xl border-none bg-transparent border-white/50 px-3 py-1 text-white placeholder:text-gray-300 placeholder:text-[12px] sm:text-sm sm:leading-6 focus:outline-none focus:ring-0 focus:shadow-lg focus:shadow-white/70 transition-shadow duration-500"
    />
  </div>
</template>

<script>
import InputLabel from "./InputLabel.vue"; // Import the new Label component

export default {
  name: "InputForm",
  components: {
    InputLabel,
  },
  props: {
    label: String,
    label_class: String,
    id: String,
    type: String,
    name: String,
    placeholder: String,
    input_class: String,
    modelValue: [String, Number],
    is_disabled: Boolean,
    is_required: Boolean,
  },
  emits: ["update:modelValue"],
  inheritAttrs: false,
};
</script>
